<template>
    <div>
        <section class="content">
            <div class="col-md-12" v-if="getMember.palmaresCombat">
                <div class="portlet light">
                    <div class="portlet-title">
                        <div class="caption pull-left">
                            <div class="subject">
                                <span class="caption-subject">Mes résultats en compétition</span>
                                <span class="caption-helper"></span>
                            </div>

                        </div>
                    </div>
                    <div class="portlet-body">
                        <table class="table table-responsive table-hover"
                               v-if="getMember.palmaresCombat.length>0">
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th width="200">Compétition</th>
                                <th>Niveau</th>
                                <th>Catégorie</th>
<!--                                <th>Grade</th>-->
                                <th>Combats gagnés</th>
<!--                                <th>Combats effectués</th>-->
                                <th>Place</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="compet in getMember.palmaresCombat">
                                <td>{{compet.date}}</td>
                                <td>{{compet.competition.competition}}</td>
                                <td>Niveau {{compet.niveau}}</td>
                                <td> {{compet.categorieAge.name}} {{compet.categorieGrade.name.replace('Catégorie', '')}} {{compet.categoriePoids.name}}</td>
<!--                                <td></td>-->
                                <td>{{compet.combatsGagnes}}</td>
<!--                                <td>{{compet.combatsEffectues}}</td>-->
                                <td>{{compet.place}}{{ getPlaceExposant(compet.place) }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="getMember.palmaresCombat.length==0">Aucun résultat en compétition trouvé</div>
                    </div>
                </div>
            </div>

        </section>
    </div>
</template>

<script type="text/babel">
    import Auth from '@/auth'
    import moment from 'moment/moment'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data() {
            return {}
        },
        methods: {
            currentYear: function () {
                return moment().year();
            },
            getPlaceExposant(place) {
                switch (place) {
                    case 1:
                        return 'er'
                    default:
                        return 'ème'
                }
            },
            getName(key) {
                switch (key) {
                    case "aisf":
                        return "AISF";
                        break;
                    case "abft":
                        return "ABFT";
                        break;
                    case "abitre_cbt":
                        return "Arbitrage combat";
                        break;
                    case "adeps":
                        return "ADEPS";
                        break;
                    case "arbitre_tch":
                        return "Arbitrage technique";
                        break;
                    case "ETU":
                        return "ETU";
                        break;
                    case "WTF":
                        return "WT";
                        break;
                }
                return "";
            },
            // getFormationsOrdered: function () {
            //     let ordered = [];
            //     let these = this
            //     this.getOrder().forEach(function (item, index, array) {
            //         if (these.getMember.formations[item])
            //             ordered.push({item: these.getMember.formations[item]});
            //     })
            //     return ordered;
            // },
            getPalmaresCombat() {
                return this.getMember.palmaresCombat && this.getMember.palmaresCombat.length > 0 ? this.getMember.palmaresCombat : []


            },
            // getFormations() {
            //     return [
            //         this.getMember().formations.aisf,
            //         this.getMember().formations.adeps,
            //         this.getMember().formations.abitre_cbt,
            //         this.getMember().formations.arbitre_tch,
            //         this.getMember().formations.abft
            //     ]
            // },
            getOrderByDate(formations) {
                return _.sortBy(formations, 'dateSorted',).reverse()
            }
        },
        components: {},
        computed: {
            ...mapGetters({
                getMember: 'getMember'
            })
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Member/SyllabusEtDocuments.vue